module.exports = __webpack_public_path__ + "static/img/2.1.4609efb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/eng/2.1.png
// module id = l/u6
// module chunks = 0